//export const base_url_url = "images/";
export const base_url_url = process.env.PUBLIC_URL+"/images/";

